// frontend/src/hooks/useMyTrades.ts
import { useQuery } from '@tanstack/react-query'
import { useAccount } from 'wagmi'
import { apiClient } from '../lib/api'

export function useMyTrades() {
  const { address } = useAccount()
  return useQuery({
    queryKey: ['p2p', 'trades', 'me', address?.toLowerCase()],
    queryFn: () => apiClient.getMyP2PTrades(address!),
    enabled: !!address,
    refetchInterval: 10_000,
  })
}
